<template>
  <div>

    <b-card-code>
      <b-row style="margin-top: -2em; margin-bottom: 1em">
        <b-col
            md="8"
            xl="8"
        >
          <div class="font-medium-3 font-weight-bold">Fehlercode S1 und S2</div>
        </b-col>
        <b-col
            md="12"
            xl="12"
        >
          <hr>
          Der Fehlercode S1 und S2 zeigt an, dass das System diesen Kunden in SevDesk nicht finden konnte, obwohl er dort registriert ist. Um das Problem zu lösen, entfernen Sie bitte die Verknüpfung zu SevDesk über die Bearbeitungsmaske des Rechnungskunden. Bitte beachten Sie, dass nur die Verknüpfung aufgelöst wird, während der Kunde im SevDesk möglicherweise weiterhin existiert, jedoch unter einer anderen ID geführt wird, falls vorhanden.</b-col>
      </b-row>
    </b-card-code>
  </div>
</template>
<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import BCardCode from '@core/components/b-card-code'
import { BBadge, BCol, BFormGroup, BFormInput, BRow } from 'bootstrap-vue'

@Component({
  components: {
    BFormGroup,
    BCol,
    BRow,
    BFormInput,
    BBadge,
    BCardCode
  }
})
export default class Fix extends Vue {
}
</script>
